import { render, staticRenderFns } from "./Giro.vue?vue&type=template&id=70c69a73"
import script from "./Giro.vue?vue&type=script&lang=js"
export * from "./Giro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports